import React from "react";
import { motion } from "framer-motion";
import { ArrowDown, Download, Mail } from "lucide-react";

export default function HeroSection() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      {/* Extra gradient overlay for hero readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent pointer-events-none" />

      {/* Noise overlay */}
      <div className="absolute inset-0 noise-overlay pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 pb-20 sm:pb-28 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="section-number mb-6" data-testid="hero-role-tags">
            AI Artist &middot; AI-VFX Lead &middot; AD (VFX)
          </p>

          <h1
            className="font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white max-w-4xl"
            data-testid="hero-heading"
          >
            Cinematic AI{" "}
            <span className="font-serif-accent text-amber-400">
              for film-scale
            </span>{" "}
            VFX.
          </h1>

          <p
            className="mt-8 text-base sm:text-lg text-neutral-400 leading-relaxed max-w-2xl"
            data-testid="hero-description"
          >
            I design photoreal AI-VFX keyframes, director-facing ideation, set
            extension logic, identity-locked references, and full-sequence AI
            previz for feature film production. Currently leading AI workflows
            for <span className="text-white font-medium">RAAKA</span> in
            Chennai.
          </p>

          <div className="flex flex-wrap gap-4 mt-10">
            <a
              href="#deliverables"
              data-testid="hero-cta-work"
              className="inline-flex items-center gap-2 px-6 py-3 bg-amber-500 text-black font-medium rounded-full hover:bg-amber-400 transition-all duration-300 text-sm"
            >
              View Deliverables
              <ArrowDown size={16} />
            </a>
            <a
              href="mailto:mijomijoarun@gmail.com"
              data-testid="hero-cta-contact"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 text-white rounded-full hover:bg-white/5 transition-all duration-300 text-sm"
            >
              <Mail size={16} />
              Contact
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-resume"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 text-white rounded-full hover:bg-white/5 transition-all duration-300 text-sm"
            >
              <Download size={16} />
              Resume
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <ArrowDown size={20} className="text-white/30" />
      </motion.div>
    </section>
  );
}
